<template>
  <panel-layout
    id="sms-panel"
    :heading="$t('pages.message.send.sms.heading')"
    :loading="loading"
    :show-footer="false"
  >
    <template #actions-right>
      <div class="flex items-center space-x-1">
        <o-tooltip class="h-8" :text="$t('general.sendSMS')">
          <o-button
            size="slim"
            flat
            icon="send"
            :disabled="!recipients.length || !$grants.all({ marketing: ['send'] })"
            @click="handleSend"
          />
        </o-tooltip>
      </div>
    </template>

    <div class="h-full">
      <o-scroll class="bg-gray-50 dark:bg-gray-900">
        <div class="h-full flex flex-col">
          <div class="flex flex-col divide-y">
            <o-form ref="form">
              <div class="flex items-center py-2 px-6">
                <p class="text-gray-600 text-sm font-medium w-32 flex-shrink-0 dark:text-gray-300">
                  {{ $t('general.customers') }}
                </p>
                <div class="flex-grow">
                  <customer-select
                    v-model="recipients"
                    :class="recipients && recipients.length ? '' : '-ml-3'"
                    base-class=""
                    container-class=""
                    border=""
                    shadow=""
                    default-status-class=""
                    default-size-class=""
                    input-class="flex-grow text-gray-800 bg-transparent ml-1 mb-1 p-2 focus:bg-gray-200 rounded-md leading-none bg-blue-600 dark:bg-blue-500 dark:focus:bg-gray-800 dark:text-gray-100"
                  />
                </div>
              </div>
            </o-form>
          </div>
          <div class="flex-grow flex-shrink h-10">
            <client-only>
              <o-sms v-model="body" :placeholder="$t('pages.message.send.sms.content')" class="h-full" />
            </client-only>
          </div>
        </div>
      </o-scroll>
    </div>

    <o-dialog
      ref="confirmDialog"
      :title="$t('message.lost')"
      :info="$t('message.lostInfo')"
      :options="[
        { text: $t('general.back'), type: 'cancel' },
        { text: $t('message.close'), type: 'confirm', variant: 'danger', callback: () => cancel(true) }
      ]"
      :portal="panel.portal"
    />
  </panel-layout>
</template>
<script setup lang="ts">
// @ts-ignore
import PanelLayout from '@/components/panel/PanelLayout.vue'

// @ts-ignore
import CustomerSelect from '@/components/customer/elements/Select.vue'

import { usePanel } from '~/composables/usePanel'

const { $api, $notification, $i18n } = useNuxtApp()

const panel = usePanel()

const props = defineProps<{
  customers?: any[]
}>()

const recipients = ref<any[]>([...(props.customers || [])])
const body = ref('')
const loading = ref(false)

const form = ref<any>()
const confirmDialog = ref<any>()

const validate = async () => {
  return await form.value.validate() && recipients.value.length
}

const handleSend = async () => {
  const valid = await validate()

  if (valid) {
    loading.value = true

    try {
      const customers = recipients.value.map(({ idCustomer }: any) => idCustomer)
      const success = await $api.marketing.sendSMS({ customers, body: body.value })

      if (success) {
        $notification.toast({
          title: $i18n.t('pages.message.send.sms.success'),
          icon: 'sms',
          variant: 'success',
        })

        cancel(true)
      }
    } catch (e: any) {
      console.log(e)
      $notification.error({ errors: e?.errors })
    }
  }

  loading.value = false
}

const cancel = (force = false) => {
  if (!force && (body.value || recipients.value.length)) {
    confirmDialog.value.open()
  } else {
    panel.close(force)
  }
}
</script>
